// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deicing-dashboard {
    background: #f1f6f9;
    color: #1b3044;
    padding: 18px;
    font-size: 13px;
    border-radius: 8px;
}
.deicing-dashboard * {
    box-sizing: border-box;
}
.deicing-dashboard button,
.deicing-dashboard select,
.deicing-dashboard input {
    font: inherit;
    border: 1px solid #cbdbe6;
    border-radius: 5px;
    padding: 8px 12px;
    color: #17466b;
    background: white;
}
.deicing-dashboard button {
    cursor: pointer;
}
.deicing-dashboard button:disabled {
    opacity: 0.6;
    cursor: wait;
}
.deicing-dashboard button:focus-visible,
.deicing-dashboard select:focus-visible,
.deicing-dashboard input:focus-visible {
    outline: 2px solid #168ab5;
    outline-offset: 2px;
}
.dd-period {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    background: white;
    padding: 8px 12px;
    border: 1px solid #e1eaf1;
    border-radius: 9px;
    margin-bottom: 14px;
}
.dd-period > strong,
.dd-panel h3 {
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-size: 11px;
    color: #708398;
    margin: 0;
}
.dd-period label {
    display: flex;
    align-items: center;
    gap: 6px;
}
.dd-segments {
    display: flex;
    background: #edf3f7;
    border-radius: 6px;
    flex-wrap: wrap;
}
.dd-segments button {
    background: transparent;
    border: 0;
}
.dd-segments button[aria-pressed="true"] {
    background: #104266;
    color: white;
}
.dd-period .dd-refresh {
    margin-left: auto;
}
.dd-kpis {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 14px;
    margin-bottom: 14px;
}
.dd-panel {
    background: white;
    border: 1px solid #e0e9f0;
    border-radius: 10px;
    padding: 20px;
    min-width: 0;
}
.dd-panel p {
    font-size: 12px;
    line-height: 1.5;
    color: #6d8093;
    margin: 8px 0;
}
.dd-panel h3 small {
    display: block;
    font-size: 10px;
    text-transform: none;
    letter-spacing: 0;
    margin-top: 5px;
    font-weight: 400;
}
.dd-kpi {
    border-top: 3px solid #1180a3;
    min-height: 170px;
}
.dd-kpi.dd-fluid-0 {
    border-top-color: #ed7a0b;
}
.dd-kpi.dd-fluid-1 {
    border-top-color: #23886d;
}
.dd-kpi:last-child {
    border-top-color: #3da9d5;
}
.dd-value {
    font-size: clamp(27px, 3vw, 38px);
    font-weight: 700;
    margin: 10px 0;
}
.dd-value small {
    font-size: 13px;
    font-weight: 400;
    color: #6d8093;
}
.dd-badge {
    background: #e3f4fa;
    border-radius: 16px;
    padding: 3px 8px;
    display: inline-block;
}
.dd-two-columns {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
    margin-bottom: 14px;
}
.dd-panel-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
}
.dd-panel-heading > b {
    font-size: 21px;
}
.dd-forecast {
    background: #0a4663;
    color: white;
    border-color: #0a4663;
}
.dd-forecast h3,
.dd-forecast p {
    color: #b3d4e4;
}
.dd-forecast p b {
    color: white;
}
.dd-forecast .dd-forecast-segments {
    background: #2c617b;
    padding: 3px;
}
.dd-forecast-segments button {
    padding: 7px 10px;
    color: #c3dfec;
    font-size: 11px;
    font-weight: 600;
}
.dd-forecast-segments button[aria-pressed="true"] {
    background: white;
    color: #104266;
}
.dd-forecast-value {
    font-size: 54px;
    margin-bottom: 0;
}
.dd-days {
    font-size: 29px;
    font-weight: 700;
    margin-top: 15px;
}
.dd-estimate {
    margin-top: 12px;
    font-size: 12px;
}
.dd-estimate b {
    float: right;
}
.dd-estimate progress {
    width: 100%;
    height: 9px;
    border: 0;
    border-radius: 6px;
    overflow: hidden;
    background: #376780;
    accent-color: #f5ba61;
}
.dd-estimate progress::-webkit-progress-bar {
    background: #376780;
}
.dd-estimate progress::-webkit-progress-value {
    background: #f5ba61;
}
.dd-estimate.dd-fluid-1 progress {
    accent-color: #80d5ae;
}
.dd-estimate.dd-fluid-1 progress::-webkit-progress-value {
    background: #80d5ae;
}
.dd-estimate.dd-fluid-2 progress {
    accent-color: #8ac5e0;
}
.dd-estimate.dd-fluid-2 progress::-webkit-progress-value {
    background: #8ac5e0;
}
.dd-estimate progress::-moz-progress-bar {
    background: #f5ba61;
}
.dd-estimate.dd-fluid-1 progress::-moz-progress-bar {
    background: #80d5ae;
}
.dd-estimate.dd-fluid-2 progress::-moz-progress-bar {
    background: #8ac5e0;
}
.dd-forecast .dd-order {
    background: #2c617b;
    border-radius: 5px;
    padding: 10px;
    color: white;
    margin-top: 18px;
}
.dd-consumption {
    margin-top: 25px;
}
.dd-consumption > div:first-child {
    display: flex;
    justify-content: space-between;
    gap: 12px;
}
.dd-consumption-track {
    height: 12px;
    border-radius: 5px;
    background: #ebc7a6;
    overflow: hidden;
    margin-top: 8px;
}
.dd-consumption-track span {
    display: block;
    height: 100%;
    background: #df7b13;
}
.dd-fluid-1 .dd-consumption-track {
    background: #a0c7ba;
}
.dd-fluid-1 .dd-consumption-track span {
    background: #238468;
}
.dd-fluid-2 .dd-consumption-track {
    background: #a4cee9;
}
.dd-fluid-2 .dd-consumption-track span {
    background: #2f91ce;
}
.dd-fluid-0.dd-average > b,
.dd-fluid-0.dd-consumption > div:first-child > b:first-child {
    color: #b76514;
}
.dd-fluid-1.dd-average > b,
.dd-fluid-1.dd-consumption > div:first-child > b:first-child {
    color: #238468;
}
.dd-fluid-2.dd-average > b,
.dd-fluid-2.dd-consumption > div:first-child > b:first-child {
    color: #2788c0;
}
.dd-muted {
    color: #a8b4bf;
}
.dd-trend-row {
    display: grid;
    grid-template-columns: minmax(0, 3fr) minmax(240px, 1fr);
    gap: 14px;
    margin-bottom: 14px;
}
.dd-trend {
    height: 300px;
}
.dd-trend-row > .dd-panel:first-child {
    display: flex;
    flex-direction: column;
}
.dd-trend-row .dd-trend {
    flex: 1;
    min-height: 300px;
}
.dd-average {
    margin-top: 20px;
    padding-bottom: 12px;
    border-bottom: 1px solid #edf2f5;
}
.dd-average > div {
    display: flex;
    gap: 25px;
    margin-top: 10px;
}
.dd-average span {
    font-size: 11px;
    color: #708398;
}
.dd-average strong {
    display: block;
    font-size: 23px;
    color: #21384b;
}
.dd-average .dd-comparison {
    display: table;
    margin: 16px 0 0 auto;
    padding: 3px 9px;
    border-radius: 16px;
    background: #edf3f7;
    color: #1b3044;
    font-weight: 600;
}
.dd-three-columns {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 14px;
}
.dd-weather {
    height: 230px;
}
.dd-airlines {
    margin-top: 14px;
}
.dd-airline-ranking {
    list-style: none;
    margin: 18px 0 0;
    padding: 0;
}
.dd-airline-ranking li {
    display: grid;
    grid-template-columns: minmax(90px, 1fr) minmax(60px, 1.4fr) minmax(95px, auto);
    align-items: center;
    gap: 12px;
    margin-top: 12px;
    font-size: 12px;
}
.dd-airline-name {
    overflow-wrap: anywhere;
}
.dd-airline-track {
    height: 18px;
    background: #edf3f8;
    border-radius: 4px;
    overflow: hidden;
}
.dd-airline-track > span {
    display: block;
    height: 100%;
    border-radius: 4px;
}
.dd-airline-value {
    text-align: right;
    font-variant-numeric: tabular-nums;
}
.dd-airline-value b,
.dd-airline-value small {
    display: inline-block;
}
.dd-airline-value small {
    margin-left: 5px;
    color: #708398;
    font-size: 10px;
}
.deicing-dashboard details {
    color: #708398;
    font-size: 11px;
}
.deicing-dashboard footer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    padding-top: 15px;
    font-size: 11px;
    color: #708398;
}
.deicing-dashboard footer button {
    margin-left: 8px;
}
.deicing-dashboard footer button:last-child {
    background: #104266;
    color: white;
}
.dd-method {
    color: #708398;
    font-size: 11px;
    line-height: 1.5;
}
@media (max-width: 1100px) {
    .dd-kpis {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .dd-three-columns {
        grid-template-columns: 1fr;
    }
    .dd-trend-row {
        grid-template-columns: minmax(0, 2fr) minmax(230px, 1fr);
    }
}
@media (max-width: 700px) {
    .deicing-dashboard {
        padding: 8px;
    }
    .dd-kpis,
    .dd-two-columns,
    .dd-trend-row {
        grid-template-columns: 1fr;
    }
    .dd-panel {
        padding: 16px;
    }
    .dd-airline-ranking li {
        grid-template-columns: minmax(0, 1fr) minmax(35px, 1fr) auto;
        gap: 8px;
    }
}
@media print {
    @page {
        size: A4 landscape;
        margin: 8mm;
    }
    body:has(.deicing-dashboard) {
        background: white;
        overflow: visible !important;
        height: auto;
    }
    body:has(.deicing-dashboard) #root,
    body:has(.deicing-dashboard) #root > div {
        height: auto !important;
        overflow: visible !important;
    }
    body:has(.deicing-dashboard) .card {
        height: auto;
        overflow: visible;
    }
    body:has(.deicing-dashboard) .card-header,
    .deicing-dashboard button,
    .deicing-dashboard footer > div,
    .deicing-dashboard details {
        display: none !important;
    }
    body:has(.deicing-dashboard) .card-body {
        overflow: visible;
        padding: 0;
        display: block;
    }
    .deicing-dashboard {
        padding: 0;
        print-color-adjust: exact;
        -webkit-print-color-adjust: exact;
    }
    .dd-panel {
        break-inside: avoid;
        padding: 12px;
    }
    .dd-kpis {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }
    .dd-three-columns {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    /* Print can start before ResizeObserver updates the charts' screen dimensions. */
    .dd-trend .recharts-responsive-container > div {
        width: 100% !important;
        height: 100% !important;
    }
    .dd-trend .recharts-wrapper {
        width: 100% !important;
        height: 100% !important;
        max-width: 100%;
    }
    .dd-trend .recharts-surface {
        max-width: 100%;
    }
    .dd-trend {
        height: 220px;
    }
    .dd-trend-row .dd-trend {
        min-height: 220px;
    }
    .dd-tabs {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/web/component/DeicingDashboard/styles.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,sBAAsB;AAC1B;AACA;;;IAGI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;AACA;IACI,YAAY;IACZ,YAAY;AAChB;AACA;;;IAGI,0BAA0B;IAC1B,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;;IAEI,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,SAAS;AACb;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,uBAAuB;IACvB,SAAS;AACb;AACA;IACI,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,YAAY;AAChB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;AACjB;AACA;IACI,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,6BAA6B;IAC7B,iBAAiB;AACrB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,SAAS;AACb;AACA;IACI,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;AACzB;AACA;;IAEI,cAAc;AAClB;AACA;IACI,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,cAAc;IACd,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;;IAEI,cAAc;AAClB;AACA;;IAEI,cAAc;AAClB;AACA;;IAEI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,aAAa;IACb,wDAAwD;IACxD,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,OAAO;IACP,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,gCAAgC;AACpC;AACA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,cAAc;IACd,eAAe;IACf,cAAc;AAClB;AACA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;AACb;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,aAAa;IACb,+EAA+E;IAC/E,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,kCAAkC;AACtC;AACA;;IAEI,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI;QACI,gDAAgD;IACpD;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,wDAAwD;IAC5D;AACJ;AACA;IACI;QACI,YAAY;IAChB;IACA;;;QAGI,0BAA0B;IAC9B;IACA;QACI,aAAa;IACjB;IACA;QACI,4DAA4D;QAC5D,QAAQ;IACZ;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,WAAW;IACf;IACA;QACI,iBAAiB;QACjB,4BAA4B;QAC5B,YAAY;IAChB;IACA;;QAEI,uBAAuB;QACvB,4BAA4B;IAChC;IACA;QACI,YAAY;QACZ,iBAAiB;IACrB;IACA;;;;QAII,wBAAwB;IAC5B;IACA;QACI,iBAAiB;QACjB,UAAU;QACV,cAAc;IAClB;IACA;QACI,UAAU;QACV,yBAAyB;QACzB,iCAAiC;IACrC;IACA;QACI,mBAAmB;QACnB,aAAa;IACjB;IACA;QACI,gDAAgD;IACpD;IACA;QACI,gDAAgD;IACpD;IACA,iFAAiF;IACjF;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;IACA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".deicing-dashboard {\n    background: #f1f6f9;\n    color: #1b3044;\n    padding: 18px;\n    font-size: 13px;\n    border-radius: 8px;\n}\n.deicing-dashboard * {\n    box-sizing: border-box;\n}\n.deicing-dashboard button,\n.deicing-dashboard select,\n.deicing-dashboard input {\n    font: inherit;\n    border: 1px solid #cbdbe6;\n    border-radius: 5px;\n    padding: 8px 12px;\n    color: #17466b;\n    background: white;\n}\n.deicing-dashboard button {\n    cursor: pointer;\n}\n.deicing-dashboard button:disabled {\n    opacity: 0.6;\n    cursor: wait;\n}\n.deicing-dashboard button:focus-visible,\n.deicing-dashboard select:focus-visible,\n.deicing-dashboard input:focus-visible {\n    outline: 2px solid #168ab5;\n    outline-offset: 2px;\n}\n.dd-period {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 12px;\n    background: white;\n    padding: 8px 12px;\n    border: 1px solid #e1eaf1;\n    border-radius: 9px;\n    margin-bottom: 14px;\n}\n.dd-period > strong,\n.dd-panel h3 {\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    font-size: 11px;\n    color: #708398;\n    margin: 0;\n}\n.dd-period label {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n.dd-segments {\n    display: flex;\n    background: #edf3f7;\n    border-radius: 6px;\n    flex-wrap: wrap;\n}\n.dd-segments button {\n    background: transparent;\n    border: 0;\n}\n.dd-segments button[aria-pressed=\"true\"] {\n    background: #104266;\n    color: white;\n}\n.dd-period .dd-refresh {\n    margin-left: auto;\n}\n.dd-kpis {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 14px;\n    margin-bottom: 14px;\n}\n.dd-panel {\n    background: white;\n    border: 1px solid #e0e9f0;\n    border-radius: 10px;\n    padding: 20px;\n    min-width: 0;\n}\n.dd-panel p {\n    font-size: 12px;\n    line-height: 1.5;\n    color: #6d8093;\n    margin: 8px 0;\n}\n.dd-panel h3 small {\n    display: block;\n    font-size: 10px;\n    text-transform: none;\n    letter-spacing: 0;\n    margin-top: 5px;\n    font-weight: 400;\n}\n.dd-kpi {\n    border-top: 3px solid #1180a3;\n    min-height: 170px;\n}\n.dd-kpi.dd-fluid-0 {\n    border-top-color: #ed7a0b;\n}\n.dd-kpi.dd-fluid-1 {\n    border-top-color: #23886d;\n}\n.dd-kpi:last-child {\n    border-top-color: #3da9d5;\n}\n.dd-value {\n    font-size: clamp(27px, 3vw, 38px);\n    font-weight: 700;\n    margin: 10px 0;\n}\n.dd-value small {\n    font-size: 13px;\n    font-weight: 400;\n    color: #6d8093;\n}\n.dd-badge {\n    background: #e3f4fa;\n    border-radius: 16px;\n    padding: 3px 8px;\n    display: inline-block;\n}\n.dd-two-columns {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 14px;\n    margin-bottom: 14px;\n}\n.dd-panel-heading {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 10px;\n}\n.dd-panel-heading > b {\n    font-size: 21px;\n}\n.dd-forecast {\n    background: #0a4663;\n    color: white;\n    border-color: #0a4663;\n}\n.dd-forecast h3,\n.dd-forecast p {\n    color: #b3d4e4;\n}\n.dd-forecast p b {\n    color: white;\n}\n.dd-forecast .dd-forecast-segments {\n    background: #2c617b;\n    padding: 3px;\n}\n.dd-forecast-segments button {\n    padding: 7px 10px;\n    color: #c3dfec;\n    font-size: 11px;\n    font-weight: 600;\n}\n.dd-forecast-segments button[aria-pressed=\"true\"] {\n    background: white;\n    color: #104266;\n}\n.dd-forecast-value {\n    font-size: 54px;\n    margin-bottom: 0;\n}\n.dd-days {\n    font-size: 29px;\n    font-weight: 700;\n    margin-top: 15px;\n}\n.dd-estimate {\n    margin-top: 12px;\n    font-size: 12px;\n}\n.dd-estimate b {\n    float: right;\n}\n.dd-estimate progress {\n    width: 100%;\n    height: 9px;\n    border: 0;\n    border-radius: 6px;\n    overflow: hidden;\n    background: #376780;\n    accent-color: #f5ba61;\n}\n.dd-estimate progress::-webkit-progress-bar {\n    background: #376780;\n}\n.dd-estimate progress::-webkit-progress-value {\n    background: #f5ba61;\n}\n.dd-estimate.dd-fluid-1 progress {\n    accent-color: #80d5ae;\n}\n.dd-estimate.dd-fluid-1 progress::-webkit-progress-value {\n    background: #80d5ae;\n}\n.dd-estimate.dd-fluid-2 progress {\n    accent-color: #8ac5e0;\n}\n.dd-estimate.dd-fluid-2 progress::-webkit-progress-value {\n    background: #8ac5e0;\n}\n.dd-estimate progress::-moz-progress-bar {\n    background: #f5ba61;\n}\n.dd-estimate.dd-fluid-1 progress::-moz-progress-bar {\n    background: #80d5ae;\n}\n.dd-estimate.dd-fluid-2 progress::-moz-progress-bar {\n    background: #8ac5e0;\n}\n.dd-forecast .dd-order {\n    background: #2c617b;\n    border-radius: 5px;\n    padding: 10px;\n    color: white;\n    margin-top: 18px;\n}\n.dd-consumption {\n    margin-top: 25px;\n}\n.dd-consumption > div:first-child {\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n}\n.dd-consumption-track {\n    height: 12px;\n    border-radius: 5px;\n    background: #ebc7a6;\n    overflow: hidden;\n    margin-top: 8px;\n}\n.dd-consumption-track span {\n    display: block;\n    height: 100%;\n    background: #df7b13;\n}\n.dd-fluid-1 .dd-consumption-track {\n    background: #a0c7ba;\n}\n.dd-fluid-1 .dd-consumption-track span {\n    background: #238468;\n}\n.dd-fluid-2 .dd-consumption-track {\n    background: #a4cee9;\n}\n.dd-fluid-2 .dd-consumption-track span {\n    background: #2f91ce;\n}\n.dd-fluid-0.dd-average > b,\n.dd-fluid-0.dd-consumption > div:first-child > b:first-child {\n    color: #b76514;\n}\n.dd-fluid-1.dd-average > b,\n.dd-fluid-1.dd-consumption > div:first-child > b:first-child {\n    color: #238468;\n}\n.dd-fluid-2.dd-average > b,\n.dd-fluid-2.dd-consumption > div:first-child > b:first-child {\n    color: #2788c0;\n}\n.dd-muted {\n    color: #a8b4bf;\n}\n.dd-trend-row {\n    display: grid;\n    grid-template-columns: minmax(0, 3fr) minmax(240px, 1fr);\n    gap: 14px;\n    margin-bottom: 14px;\n}\n.dd-trend {\n    height: 300px;\n}\n.dd-trend-row > .dd-panel:first-child {\n    display: flex;\n    flex-direction: column;\n}\n.dd-trend-row .dd-trend {\n    flex: 1;\n    min-height: 300px;\n}\n.dd-average {\n    margin-top: 20px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid #edf2f5;\n}\n.dd-average > div {\n    display: flex;\n    gap: 25px;\n    margin-top: 10px;\n}\n.dd-average span {\n    font-size: 11px;\n    color: #708398;\n}\n.dd-average strong {\n    display: block;\n    font-size: 23px;\n    color: #21384b;\n}\n.dd-average .dd-comparison {\n    display: table;\n    margin: 16px 0 0 auto;\n    padding: 3px 9px;\n    border-radius: 16px;\n    background: #edf3f7;\n    color: #1b3044;\n    font-weight: 600;\n}\n.dd-three-columns {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 14px;\n}\n.dd-weather {\n    height: 230px;\n}\n.dd-airlines {\n    margin-top: 14px;\n}\n.dd-airline-ranking {\n    list-style: none;\n    margin: 18px 0 0;\n    padding: 0;\n}\n.dd-airline-ranking li {\n    display: grid;\n    grid-template-columns: minmax(90px, 1fr) minmax(60px, 1.4fr) minmax(95px, auto);\n    align-items: center;\n    gap: 12px;\n    margin-top: 12px;\n    font-size: 12px;\n}\n.dd-airline-name {\n    overflow-wrap: anywhere;\n}\n.dd-airline-track {\n    height: 18px;\n    background: #edf3f8;\n    border-radius: 4px;\n    overflow: hidden;\n}\n.dd-airline-track > span {\n    display: block;\n    height: 100%;\n    border-radius: 4px;\n}\n.dd-airline-value {\n    text-align: right;\n    font-variant-numeric: tabular-nums;\n}\n.dd-airline-value b,\n.dd-airline-value small {\n    display: inline-block;\n}\n.dd-airline-value small {\n    margin-left: 5px;\n    color: #708398;\n    font-size: 10px;\n}\n.deicing-dashboard details {\n    color: #708398;\n    font-size: 11px;\n}\n.deicing-dashboard footer {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 14px;\n    padding-top: 15px;\n    font-size: 11px;\n    color: #708398;\n}\n.deicing-dashboard footer button {\n    margin-left: 8px;\n}\n.deicing-dashboard footer button:last-child {\n    background: #104266;\n    color: white;\n}\n.dd-method {\n    color: #708398;\n    font-size: 11px;\n    line-height: 1.5;\n}\n@media (max-width: 1100px) {\n    .dd-kpis {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n    .dd-three-columns {\n        grid-template-columns: 1fr;\n    }\n    .dd-trend-row {\n        grid-template-columns: minmax(0, 2fr) minmax(230px, 1fr);\n    }\n}\n@media (max-width: 700px) {\n    .deicing-dashboard {\n        padding: 8px;\n    }\n    .dd-kpis,\n    .dd-two-columns,\n    .dd-trend-row {\n        grid-template-columns: 1fr;\n    }\n    .dd-panel {\n        padding: 16px;\n    }\n    .dd-airline-ranking li {\n        grid-template-columns: minmax(0, 1fr) minmax(35px, 1fr) auto;\n        gap: 8px;\n    }\n}\n@media print {\n    @page {\n        size: A4 landscape;\n        margin: 8mm;\n    }\n    body:has(.deicing-dashboard) {\n        background: white;\n        overflow: visible !important;\n        height: auto;\n    }\n    body:has(.deicing-dashboard) #root,\n    body:has(.deicing-dashboard) #root > div {\n        height: auto !important;\n        overflow: visible !important;\n    }\n    body:has(.deicing-dashboard) .card {\n        height: auto;\n        overflow: visible;\n    }\n    body:has(.deicing-dashboard) .card-header,\n    .deicing-dashboard button,\n    .deicing-dashboard footer > div,\n    .deicing-dashboard details {\n        display: none !important;\n    }\n    body:has(.deicing-dashboard) .card-body {\n        overflow: visible;\n        padding: 0;\n        display: block;\n    }\n    .deicing-dashboard {\n        padding: 0;\n        print-color-adjust: exact;\n        -webkit-print-color-adjust: exact;\n    }\n    .dd-panel {\n        break-inside: avoid;\n        padding: 12px;\n    }\n    .dd-kpis {\n        grid-template-columns: repeat(4, minmax(0, 1fr));\n    }\n    .dd-three-columns {\n        grid-template-columns: repeat(3, minmax(0, 1fr));\n    }\n    /* Print can start before ResizeObserver updates the charts' screen dimensions. */\n    .dd-trend .recharts-responsive-container > div {\n        width: 100% !important;\n        height: 100% !important;\n    }\n    .dd-trend .recharts-wrapper {\n        width: 100% !important;\n        height: 100% !important;\n        max-width: 100%;\n    }\n    .dd-trend .recharts-surface {\n        max-width: 100%;\n    }\n    .dd-trend {\n        height: 220px;\n    }\n    .dd-trend-row .dd-trend {\n        min-height: 220px;\n    }\n    .dd-tabs {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
